export default __webpack_public_path__ + "static/media/stackexchange.3411ff00.webp";